import React from "react";
import PropTypes from "prop-types";
import withIntl from "../../utils/withIntl";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import { withRouter } from "react-router-dom";
import { useTheme } from "@material-ui/core/styles";
import AuthorizationWrapper from "../AuthorizationWrapper";

function CollectionMenuItem(props) {
  const theme = useTheme();

  const handleOnClickLink = () => {
    props.onClick();
  };

  const item = (
    <ListItem button selected={false} onClick={handleOnClickLink}>
      <ListItemIcon style={{ color: props.link.match(props.location.pathname) ? theme.palette.primary.main : null }}>
        {props.link.icon}
      </ListItemIcon>
      <ListItemText
        primary={props.intl.formatMessage({ id: props.link.name })}
        secondary={props.link.subtitle ? props.intl.formatMessage({ id: props.link.subtitle }) : null}
      />
    </ListItem>
  );
  if (props.link.authenticationName) {
    return <AuthorizationWrapper permission={props.link.authenticationName} child={item} />;
  } else {
    return item;
  }
}

CollectionMenuItem.propTypes = {
  onClick: PropTypes.func.isRequired,
  link: PropTypes.object.isRequired,
  setSubDrawerOpen: PropTypes.func.isRequired,
};

export default withRouter(withIntl(CollectionMenuItem));
